import { ChangeEvent, FunctionComponent } from 'react';
import classnames from 'classnames';

import InputWrapper from 'components/layout/forms/InputWrapper';

import { Props } from './index';
import StyledComponent from './styles';

const LayoutFormsInput: FunctionComponent<Props> = ({
    className,
    name,
    value,
    onChange,
    style,
    styles,
    disabled,
    label,
    error,
    required,
    disableDefaultRequiredBehaviour = false,
}) => {
    return (
        <StyledComponent
            className={classnames(
                'layout-forms-checkbox',
                className,
                [`style-${style}`],
                {
                    'error': Boolean(error),
                    'disabled': disabled,
                }
            )}
            style={styles}
        >
            <InputWrapper
                name={name}
                error={error}
                disabled={disabled}
            >
                <label
                    htmlFor={name}
                    className="checkbox-wrapper"
                >
                    <input
                        id={name}
                        name={name}
                        className="checkbox"
                        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event)}
                        type="checkbox"
                        value={value}
                        checked={Boolean(value)}
                        disabled={disabled}
                        required={disableDefaultRequiredBehaviour ? false : required}
                    />
                    <span className="checkbox-trigger" />
                    <span className="label">
                        <span dangerouslySetInnerHTML={{ __html: label }} />
                    </span>
                </label>

            </InputWrapper>
        </StyledComponent>
    );
};

export default LayoutFormsInput;
